<section class="py-16">
  <div>
    <!-- Badge -->
    <div class="flex justify-center" data-aos="fade-up">
      <span
        data-aos="fade-up"
        class="inline-flex items-center justify-center gap-2 px-2.5 py-1.5 rounded-full border"
      >
        <span class="text-black font-medium text-base">
          {{ "recruiterProgram.whyUs.badge" | translate }}
        </span>
        <app-icon name="svg:logo-white" [size]="24" />
      </span>
    </div>

    <!-- Title -->
    <h2
      class="text-center text-[32px] md:text-[44px] lg:text-[52px] font-black leading-tight tracking-[-2px] text-[#000D4A] mt-6 mb-[80px]"
      data-aos="fade-up"
      data-aos-delay="50"
    >
      {{ "recruiterProgram.whyUs.title" | translate }}
    </h2>

    <!--     Cards -->

    <div class="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-6">
      <div
        *ngFor="let reason of reasons; let i = index; let last = last"
        class="card border rounded-2xl text-center flex flex-col items-center gap-6 bg-white px-6 py-[72px] lg:col-span-2"
        data-aos="fade-up"
        [class.md:col-span-2]="last"
        [attr.data-aos-delay]="i * 80"
      >
        <div class="icon-container">
          <app-icon [name]="reason.icon" size="44" class="text-white" />
        </div>

        <h3 class="text-[22px] leading-[36px] text-[#000D4A] font-[800]">
          {{ reason.titleKey | translate }}
        </h3>
      </div>
    </div>
  </div>
</section>
